import {fun_Download, fun_PostAction} from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 招标编号
      projectId: null,
      // 文件类型
      fileType: null,
      // 用户编号
      tbUserId: null,
      // 资格预审形式
      prequalificationType: null,
      // 左侧目录当前选中的节点
      currentKey: null,
      // 左侧树形菜单数据
      treeData: [],
      // 中间投标单位
      bidList: [],
      // 当前选择的投标单位
      bidIndex: 0,
      // 右侧填写内容
      form: {
        id: null,
        ym: null,
        pdfPagesCount: null,
      },
      // pdf路径
      pdfUrl: null,
      // pdf总页码

    }
  },
  // 接收父组件传递的数据
  props: {

  },
  // 模板编译完成
  mounted() {

  },
  // 自定义方法
  methods: {
    /**
     * 投标单位信息一览
     * @author shuhua
     */
    fun_GetBidderList() {
      // 发起请求
      fun_PostAction("/evaluationPublicity/bidderList", {
        ...this.reqPageData,
        tenderReference: this.projectId,
        prequalificationType: this.prequalificationType
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.bidList = data;
          // 遍历
          this.bidList.map((e, index) => {
            // 如果是中标候选人名称
            if (e.tenderUnitsId == this.tbUserId) {
              this.bidIndex = index;
            }
          });

        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },

    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/evaluationPublicity/getFileLookList", {
        sectionId: this.projectId,
        fileType: this.fileType,
        tbUserId: this.tbUserId,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 赋值data
          this.treeData = data;
          // 默认选中第一个
          this.fun_HandleNodeClick(data[0]);
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },


    /**
     * iframe加载完成后执行的方法
     */
    iframeLoaded() {
      // 通过id获取iframe元素
      let iframe = document.getElementById("iframePdf");
      // 获取iframe内容文档对象
      let iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      // 获取iframe中的header元素
      let header = iframeDoc.getElementsByTagName("header")[0];
      // 存在header元素
      if (header) {
        // 修改背景颜色
        header.style.backgroundColor = "#12989b";
      }
    },
    /**
     * 点击左侧树形菜单
     */
    fun_HandleNodeClick(data) {
      // 路径不为空
      if (data.filePath != null && data.filePath != "") {
        // 赋值
        this.currentKey = data.id;
        // 获取pdf
        const iframePdf = document.getElementById("iframePdf").contentWindow;
        // 赋值
        this.form = data;
        // 总页码
        this.form.pdfPagesCount = iframePdf.PDFViewerApplication.pagesCount;
        // 回调设置样式
        // this.$nextTick(() => {
        //   // 设置选中样式
        //   this.$refs.fileTree.setCurrentKey(data.id);
        // });
        this.fun_OpenPdf(data.filePath);
      }
    },

    /**
     * 调用PDF
     */
    fun_OpenPdf(e){
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        // 存储this
        const data = new Blob([res.data], { type: "application/pdf" });
        // 预览PDF
        this.pdfUrl =
            URL.createObjectURL(data);
      });
    },
    /**
     * 点击投标单位
     */
    fun_GetBidClick(val,index){
      // 获取用户id
      this.tbUserId = val.tenderUnitsId;
      // 遍历文件
      this.fun_GetList();
      // 获取点击的投标单位下标
      this.bidIndex = index;

    },
    /**
     * 确认按钮
     */
    fun_GetAffirm(){
      // 请求
      fun_PostAction("/evaluationPublicity/saveOrUpdate", {
        ...this.form, // form表单数据
      }).then(res => {
        // 解构res.data
        const {result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
  }
}